import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-geist-sans\"}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/BuyMeACoffeeButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
